module.exports = __webpack_public_path__ + "img/logo-health-hub.1a12a5c2.svg";